import { useI18n } from "../i18n.jsx";
import PlusNudge from "./PlusNudge.jsx";

export default function PlusUpgradePanel({
  compact = false,
  source = "upgrade-panel",
  title = null,
  copy = null
}) {
  const { t } = useI18n();
  const upgradeTitle = title || t("plus.contactTitle");
  const upgradeCopy = copy || t("plus.upgradeCopy");

  return (
    <section className={compact ? "plus-upgrade-panel is-compact" : "plus-upgrade-panel"} aria-label={t("plus.upgradeLabel")}>
      <div className="plus-upgrade-copy">
        <p className="kicker">SielpA Plus</p>
        <h3>{upgradeTitle}</h3>
        <p>{upgradeCopy}</p>
        <p>{t("plus.contactCopy")}</p>
      </div>

      {!compact ? (
        <div className="plus-upgrade-feature-list" aria-label={t("plus.featuresLabel")}>
          <span>{t("plus.noAds")}</span>
          <span>{t("plus.premiumVoice")}</span>
          <span>{t("plus.vocabBurst")}</span>
        </div>
      ) : null}

      <div className="plus-plan-actions">
        <PlusNudge className="primary-button plus-contact-button" source={source} showWhenPlus>
          {t("plus.emailUs")}
        </PlusNudge>
      </div>

    </section>
  );
}
